import { CallApi, handleJSONResponse } from "./common";
import { Balance } from "../../../../services/royalties/types/balance";
import { AdminListBalancesResponse } from "../../../../services/royalties/types/api/admin-list-balances-response";
import { AdminGetStatementResponse } from "../../../../services/royalties/types/api/admin-get-statements-response";
import { MarkPaymentRequest } from "../../../../services/royalties/types/api/admin-mark-payment-request";
import DineroFactory, { Dinero, DineroObject } from "dinero.js";
import { Statement } from "../../../../services/royalties/types/statement";
import { RoyaltiesAccount } from "../../../../services/royalties/types/royalties-account";

const callAPI = CallApi("royalties/admin");

export const getAccount = async (
  userId: string
): Promise<RoyaltiesAccount | undefined> => {
  const response = await callAPI(`/account/${userId}`, "GET");
  if (response.status !== 200 && response.status !== 201) return undefined;
  return await handleJSONResponse(response);
};

export const listBalances = async (): Promise<Balance[] | undefined> => {
  const response = await callAPI(`/balance`, "GET");

  if (response.status !== 200 && response.status !== 201) return undefined;
  const apiResponse: AdminListBalancesResponse = await handleJSONResponse(
    response
  );

  return apiResponse.map((item) => ({
    ...item,
    balance: DineroFactory(item.balance),
  }));
};

export const getBalance = async (
  userId: string
): Promise<Dinero | undefined> => {
  const response = await callAPI(`/balance/${userId}`, "GET");
  if (response.status !== 200 && response.status !== 201) return undefined;
  const apiResponse: DineroObject = await handleJSONResponse(response);

  return DineroFactory(apiResponse);
};

export const getStatement = async (
  userId: string
): Promise<Statement[] | undefined> => {
  const response = await callAPI(`/statement/${userId}`, "GET");
  if (response.status !== 200 && response.status !== 201) return undefined;
  const apiResponse: AdminGetStatementResponse = await handleJSONResponse(
    response
  );

  return apiResponse.map((item) => ({
    ...item,
    earnings: DineroFactory(item.earnings),
    payouts: DineroFactory(item.payouts),
    streaming: DineroFactory(item.streaming),
    merch: DineroFactory(item.merch),
    deductions: DineroFactory(item.deductions),
  }));
};

export const markPayment = async (
  userId: string,
  data: MarkPaymentRequest
): Promise<void> => {
  const response = await callAPI(`/pay/${userId}`, "POST", data);
  await handleJSONResponse(response);
};
